export default __webpack_public_path__ + "static/media/bg-pattern-mobile.55aee912.svg";